import {Dropdown, Menu} from "antd";

function DropdownMenu(props) {

  return (
    <Dropdown
      data-testid="dropdown-menu"
      overlay={
        <Menu
          items={props.actions.map((action) =>
            ({
              onClick: action.onClick,
              disabled: action.disabled || props.disabled,
              key: action.label,
              label: action.label,
            }))
          }
        />
      }
      trigger={["hover"]}
    >
      {props.children}
    </Dropdown>
  );
}

export default DropdownMenu;
